import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offer } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
};
export function CtaButton({
  children,
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      value: offer.priceValue,
      currency: offer.currency,
      content_name: offer.productName
    });
  };
  return <a href={offer.checkoutUrl} onClick={handleClick} className={`group flex w-full items-center justify-center gap-2.5 rounded-full bg-wood px-5 py-4 text-center font-display text-[19px] uppercase leading-tight tracking-wide text-espresso shadow-cta transition-[transform,background-color] duration-150 ease-out hover:bg-wood-light focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-wood/40 active:scale-[0.98] ${className}`} data-id="element-63" data-mp="llqv76kplu22">
      <span data-id="element-64" data-mp="157dftgzd3kjc">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.5} aria-hidden="true" data-id="element-65" data-mp="35xfq5cfwjfcx" />
    </a>;
}